import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Fade, Typography } from "@mui/material";
import MobileTopBar from "../../components/navigation/MobileTopBar";
import Button from "../../components/inputs/Button";
import TabButton from "../../components/inputs/TabButton";
import MessageBox from "../../components/utils/MessageBox";

const ProfilePage = ({ mobile, height, setLoggedIn, setUser, user, handleLogout }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        height: { height },
        overflow: "scroll",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        padding: "0px 10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      {mobile > 0 && <MobileTopBar>Perfil</MobileTopBar>}
      <Box
        style={{
          maxWidth: "700px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginBottom: "10px",
            marginTop: !mobile ? "10px" : "0",
          }}
        >
          <Typography
            style={{
              width: "100%",
              textAlign: "left",
              color: "white",
              fontWeight: "500",
              fontSize: "36px",
              marginLeft: "10px",
            }}
          >
            {`${user.name} ${user.lastName}`}
          </Typography>
          <Typography
            style={{
              width: "100%",
              textAlign: "left",
              color: user.subscriptionExpire > new Date().toISOString() ? "#FF9700" : "#FF1F01",
              fontWeight: "500",
              fontSize: "18px",
              marginLeft: "10px",
            }}
          >
            {user.subscriptionExpire > new Date().toISOString() ? `${user.plan.name} vigente` : "Membresía inactiva"}
          </Typography>
        </Box>

        <TabButton sx={{ maxWidth: "700px" }}>Hablá con nuestros nutricionistas</TabButton>
        <TabButton sx={{ maxWidth: "700px" }}>Hablá con nuestros psicólogos</TabButton>
        <TabButton sx={{ maxWidth: "700px" }} onClick={() => navigate("/membresia")}>
          Gestionar membresía
        </TabButton>
        <TabButton sx={{ maxWidth: "700px" }} onClick={() => navigate("/reservas/historial")}>
          Ver historial de reservas
        </TabButton>

        <Button stroked sx={{ maxWidth: "700px", marginTop: "10px" }} onClick={handleLogout}>
          Cerrar sesión
        </Button>
        {mobile > 0 && (
          <div
            style={{
              width: "100%",
              height: "70px",
              color: "rgba(0,0,0,0)",
            }}
          >
            -
          </div>
        )}
      </Box>
    </Box>
  );
};

export default ProfilePage;
